




























import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import { useFormat, useRouter } from '@ideavivat/vivat-2';

import updateVehicle from '@/gql/vehicle/updateVehicle.gql';

const CommonModalWithVehicleAbsenceLogEditor = defineComponent({
  setup() {
    const { route } = useRouter();
    const form = reactive({
      reason: '',
      date: {
        from: '',
        to: '',
      },
    });

    const modal = ref(null);
    const vehicleId = ref(-1);
    function compose(ctx: any) {
      vehicleId.value = ctx.vehicleId;

      const nextDay = useFormat.date(useFormat.date(ctx.from).dayjs.add(1, 'day')).computerShortDate();
      form.date.from = ctx.from;
      form.date.to = nextDay;

      (modal.value as any).open();
    }
    const refetchQueries = ['getVehicles', 'getVehicle', 'getDataForVehicleCalendar'];
    const createAbsenceLogMutation = useMutation(updateVehicle, () => ({
      variables: {
        id: route.value.params.id,
        input: {
          absenceLogs: {
            create: [{
              reason: form.reason,
              leaveUntil: form.date.to,
              effectiveDate: form.date.from,
            }],
          },
        },
      },
      refetchQueries,
    }));
    const pendingEditId = ref(-1);
    const updateAbsenceLogMutation = useMutation(updateVehicle, () => ({
      variables: {
        id: vehicleId.value,
        input: {
          absenceLogs: {
            create: [{
              reason: form.reason,
              leaveUntil: form.date.to,
              effectiveDate: form.date.from,
            }],
          },
        },
      },
      refetchQueries,
    }));
    createAbsenceLogMutation.onDone(() => {
      (modal.value as any).close();
    });
    updateAbsenceLogMutation.onDone(() => {
      (modal.value as any).close();
    });

    const computedMutation = computed(() => {
      if (pendingEditId.value > -1) return updateAbsenceLogMutation;
      return createAbsenceLogMutation;
    });

    return {
      modal,
      compose,
      form,
      computedMutation,
    };
  },
});

export default CommonModalWithVehicleAbsenceLogEditor;
